import React, { Fragment } from 'react';
import Responses from "../../components/responses/responses-component";
import Filters from "../../components/filters/filters-component";
import HbIndex from "../../components/hb-index/hb-index-component";

const FiltersComponent = (
  {
    filters,
    toggleFilter,
    deleteFilter,
    loading,
    responsesLoading,
    error,
    responsesTotal,
    responsesAfter,
    responsesInfoError,
    hbIndex,
    hbIndexLoading,
    hbIndexError,
    toggleIsScore,
    reportUrl
  }
  ) => {
  return (
    <Fragment>
      <HbIndex
        loading={hbIndexLoading}
        hbIndex={hbIndex}
        error={hbIndexError}
        reportUrl={reportUrl}
      />
      <Responses
        responsesTotal={responsesTotal}
        responsesAfter={responsesAfter}
        loading={responsesLoading}
        error={responsesInfoError}
      />
      <Filters
        loading={loading}
        filters={filters}
        deleteFilter={deleteFilter}
        toggleFilter={toggleFilter}
        toggleIsScore={toggleIsScore}
        error={error}
      />
    </Fragment>
  )
};


export default FiltersComponent;


// WEBPACK FOOTER //
// ./src/modules/filters/filters-component.js